var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_38330",
    "data-name": "Group 38330",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.793,
    height: 33.718,
    viewBox: "0 0 35.793 33.718",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_11",
    "data-name": "Polygon 11",
    d: "M26.845,0l8.948,16.859L26.845,33.718H8.948L0,16.859,8.948,0Z",
    transform: "translate(0 0)",
    fill: "#a9bf6e"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_note_3938508",
    transform: "translate(9.238 8.203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3793",
    "data-name": "Rectangle 3793",
    width: 17.906,
    height: 17.906,
    transform: "translate(0 0.084)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3498",
    "data-name": "Path 3498",
    d: "M73.737,2.014,71.765,5.678a.629.629,0,0,0-.073.349l.086,1.059a.629.629,0,0,0,.931.5l.931-.512a.629.629,0,0,0,.251-.253l1.441-2.677V16.821a1.084,1.084,0,0,1-1.084,1.084h-10.2a1.084,1.084,0,0,1-1.084-1.084V3.1a1.084,1.084,0,0,1,1.084-1.084Zm-8.142,10.4h7.1a.315.315,0,1,0,0-.629h-7.1a.315.315,0,1,0,0,.629Zm0-1.819h7.1a.315.315,0,1,0,0-.629h-7.1a.315.315,0,1,0,0,.629Zm0-1.819h4.651a.315.315,0,1,0,0-.629H65.595a.315.315,0,1,0,0,.629Zm6.725-2.8L75.377.295a.56.56,0,0,1,.759-.228l.029.016a.56.56,0,0,1,.228.759L73.336,6.523l-.931.512Z",
    transform: "translate(-60.673 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notesIcon.ecf083f1f3cf12ce639ff1ba59ea17fc.svg";
export { ForwardRef as ReactComponent };